import { Module } from 'wrapper6'
import jQueryBridget from 'jquery-bridget'
import MasonryLayout from 'masonry-layout'

const $ = jQuery
jQueryBridget('masonry', MasonryLayout, $)

export default class Masonry extends Module {
  ready (app) {
    this.wrappers = document.querySelectorAll('.news-archive__inner')

    if (this.wrappers.length) {
      this.addMasonry()
    }
  }

  addMasonry () {
    if (this.wrappers.length) {
      for (let i = 0; i < this.wrappers.length; i++) {
        const wrapper = this.wrappers[i]

        const msnry = new LoadPosts(wrapper)
      }
    }
  }
}

class LoadPosts {
  constructor (wrapper) {
    this.wrapper = wrapper
    this.processing = false
    this.startPostsPerPage = parseInt(this.wrapper.getAttribute('data-start-ppp'))
    this.startOffset = parseInt(this.wrapper.getAttribute('data-start-offset'))
    this.offset = this.startOffset + this.startPostsPerPage
    this.loadOffset = parseInt(this.wrapper.getAttribute('data-load-offset'))
    this.offsetCountToAddButton = 24
    this.postCount = this.wrapper.getAttribute('data-post-count')
    this.loadMoreBtn = this.wrapper.parentElement.querySelector('.show-more')

    this.$grid = this.addMasonry()
    this.addLoadScroll()
    this.addLoadBtn()
  }

  addMasonry () {
    const $grid = $(this.wrapper).masonry({
      itemSelector: '.news_box',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      gutter: 30,
      horizontalOrder: true
    })

    return $grid
  }

  addLoadScroll () {
    document.addEventListener('scroll', () => {
      // only run if offset is smaller than post
      if (this.offset < this.postCount && (this.startPostsPerPage + this.startOffset) < this.postCount) {
        const rect = this.wrapper.getBoundingClientRect()

        // prevent to call ajax all the time
        if (this.processing) {
          return false
        }

        // show load more button if offset is bigger or equal to chosen count
        if (this.offset >= this.offsetCountToAddButton) {
          if (this.loadMoreBtn) {
            this.loadMoreBtn.classList.remove('hide')
          }
          return false
        }

        // only call ajax if bottom of element is in viewport
        if (rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
          this.addAjaxCall()
        }
      }
    })
  }

  addLoadBtn () {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', () => {
        this.addAjaxCall()
      })
    }
  }

  addAjaxCall () {
    const data = {
      action: 'addMoreNewsOnScroll',
      offset: this.offset,
      currentPostID: this.wrapper.getAttribute('data-id')
    }

    // prevent to call ajax all the time
    this.processing = true

    this.showLoader()
    this.hideButton()

    $.post(ajax_object.ajax_url, data, (response) => {
      if (response.markup !== '') {
        // append response to masonry
        const content = $(response.markup)
        this.$grid.append(content)
        this.$grid.masonry('appended', content)

        // update offset
        this.offset = this.offset += this.loadOffset

        // prevent to call ajax all the time
        this.processing = false

        this.removeErrorMessage()
      } else {
        this.addErrorMessage()
      }

      this.hideLoader()

      // show button if offset is bigger or equal to button offset count and offset is smaller than post count
      if (this.offset >= this.offsetCountToAddButton && this.offset < this.postCount) {
        this.showButton()
      }
    })
  }

  showLoader () {
    if (this.wrapper.parentElement) {
      const loader = this.wrapper.parentElement.querySelector('.loader')

      loader.classList.add('show')
    }
  }

  hideLoader () {
    if (this.wrapper.parentElement) {
      const loader = this.wrapper.parentElement.querySelector('.loader')

      loader.classList.remove('show')
    }
  }

  showButton () {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.classList.remove('hide')
    }
  }

  hideButton () {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.classList.add('hide')
    }
  }

  addErrorMessage () {
    if (!document.querySelector('.no-posts')) {
      const el = document.createElement('div')
      el.classList.add('no-posts')
      el.innerHTML = 'Der er desværre ikke flere nyheder'
      this.wrapper.parentElement.appendChild(el)
    }
  }

  removeErrorMessage () {
    if (document.querySelector('.no-posts')) {
      document.querySelector('.no-posts').parentElement.removeChild('.no-posts')
    }
  }
}
